var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 0.8125H0.625C0.453125 0.8125 0.3125 0.953125 0.3125 1.125V7.0625C0.3125 7.23438 0.453125 7.375 0.625 7.375H6.5625C6.73438 7.375 6.875 7.23438 6.875 7.0625V1.125C6.875 0.953125 6.73438 0.8125 6.5625 0.8125ZM5.54688 6.04688H1.64062V2.14062H5.54688V6.04688ZM14.375 0.8125H8.4375C8.26562 0.8125 8.125 0.953125 8.125 1.125V7.0625C8.125 7.23438 8.26562 7.375 8.4375 7.375H14.375C14.5469 7.375 14.6875 7.23438 14.6875 7.0625V1.125C14.6875 0.953125 14.5469 0.8125 14.375 0.8125ZM13.3594 6.04688H9.45312V2.14062H13.3594V6.04688ZM6.5625 8.625H0.625C0.453125 8.625 0.3125 8.76562 0.3125 8.9375V14.875C0.3125 15.0469 0.453125 15.1875 0.625 15.1875H6.5625C6.73438 15.1875 6.875 15.0469 6.875 14.875V8.9375C6.875 8.76562 6.73438 8.625 6.5625 8.625ZM5.54688 13.8594H1.64062V9.95312H5.54688V13.8594ZM14.375 8.625H8.4375C8.26562 8.625 8.125 8.76562 8.125 8.9375V14.875C8.125 15.0469 8.26562 15.1875 8.4375 15.1875H14.375C14.5469 15.1875 14.6875 15.0469 14.6875 14.875V8.9375C14.6875 8.76562 14.5469 8.625 14.375 8.625ZM13.3594 13.8594H9.45312V9.95312H13.3594V13.8594Z",
    fill: "#0FA479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard_active.9ad3a5e22da84ad4d55aef40a94dceff.svg";
export { ForwardRef as ReactComponent };